import { useTranslation } from 'react-i18next';
import { availableLanguages } from '../i18n';
import DropdownSelector from './DropdownSelector';

const ChangeLanguage = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div style={{ width: '100%', display: 'flex', gap: '8px'}}>
      <img src={require('../assets/language.svg').default} alt="Language" />
      <DropdownSelector
        onChange={changeLanguage}
        label={t("changeLanguage")}
        options={availableLanguages}
        value={i18n.language}
      />
    </div>
  )
}

export default ChangeLanguage;
